import React, {useCallback} from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import Label from '../Label';
import services from '../../api/remoteServices';
import CheckCircle from '../../assets/icons/check_circle.svg';
import './index.scss';

type DesignCardProps = {
  design: any;
  setDesign: (selectedDesignCid: string) => void;
  selected: boolean;
};

const DesignCard: React.FC<DesignCardProps> = ({
  design,
  setDesign,
  selected
}: DesignCardProps) => {
  const {composite_id: compositeId, has_sleeve_icons: hasSleeveIcons} = design;
  const onClickDesign = useCallback(() => {
    if (!hasSleeveIcons) setDesign(compositeId);
  }, [compositeId, hasSleeveIcons]);
  const productId = design.products[0].product_id;
  const designCid = design.composite_id;

  return (
    <div
      className={`designCard${selected ? ' selected' : ''}`}
      onClick={onClickDesign}
      onKeyDown={onClickDesign}
      role="radio"
      tabIndex={0}
      aria-checked="false"
      key={design.composite_id}>
      <div
        className={`designImageWrapper${!hasSleeveIcons ? '' : ' disabled'}`}>
        <object
          data={`${services.mmsImages}/catalog/colors/${productId}/views/front.jpg?design=${designCid}&pbtn=1`}>
          <SvgIcon color="disabled" component={BrokenImageIcon} />
        </object>
        {selected && (
          <div className="selectedBadgeContainer">
            <img className="selectedBadge" src={CheckCircle} alt="Selected" />
          </div>
        )}
      </div>
      <Label>
        <p>{design.design_name}</p>
        {hasSleeveIcons && <p>(disabled)</p>}
      </Label>
      <br />
    </div>
  );
};

export default DesignCard;
